import React from 'react';
import { Navigate } from 'react-router-dom';

import { useUserProfileQuery } from '@services/user/useUserProfileQuery';

const ProtectedRoute = ({ children }) => {
  const { data: profileData } = useUserProfileQuery();
  if (!profileData.userAccess.manageEquipmentDeactivation) {
    return <Navigate to="/" replace={true} />;
  }

  return children;
};

export default ProtectedRoute;
